import React, { Component } from 'react';
import { Route } from 'react-router-dom'
import Home from '../home'
import scrollToComponent from 'react-scroll-to-component'
import SideMenu from './SideMenu'

class App extends Component {
  constructor(props) {
    super(props)
    this.state = {
      sideMenu: false
    }
  }

  toggleSidebar = value => {
    return this.setState({
      sideMenu: value
    })
  }

  scrollToElement = target => {
    scrollToComponent(document.querySelector(`.${target}`), {
      align: 'top',
      duration: 400
    })
  }

  handleMenuClick = e => {
    document.body.removeAttribute("style")
    this.setState({
      menuActive: false
    })
    this.scrollToElement(e.target.name)
    this.setState({ sideMenu: false })
  }

  handleClickOutside = () => {
    // if(this.state.sideMenu) {
    //   this.setState({ sideMenu: false })
    // }
  }

  render() {
    const { sideMenu } = this.state
    return(
      <div>
        <main className={sideMenu ? 'sideMenu-active' : ''}>
          <Route exact path="/:section?" render={props => 
            <Home toggleSidebar={this.toggleSidebar.bind(this)} sideMenuActive={sideMenu} {...props} />
          } />
        </main>
        
        <SideMenu 
          visible={sideMenu}
          onClick={this.handleMenuClick}
          handleClickOutside={this.handleClickOutside} />

      </div>
    )
  }
}

// const SideMenu = ({ visible, onClick }) => (
//   <div className={visible ? 'sidemenu visible' : 'sidemenu hidden'}>
//           <div className="sidemenu-inner">
//             {menuLinks.map((link,index) => 
//                 <button 
//                   key={index} 
//                   name={link.target}
//                   onClick={onClick} 
//                   >{link.title}</button>
//             )}
//           </div>
//   </div>
// )

export default App


// WEBPACK FOOTER //
// ./src/containers/app/index.js